export default __webpack_public_path__ + "static/media/08_COUSINS-min.2122c288.jpg";